import React from 'react';
import "./Main.css";
import Hero from "./Hero/Hero";
import Background from "./Background/Background";
import Skills from "./Skills/Skills";
import PersonalDetails from "./Personal Details/PersonalDetails";

function Main() {
    return (
        <div className="gridContainerMain">
        <div className="heroMain" id="Hero"><Hero/></div><div className="seperate"></div><div className="seperate">.....</div>
          <div className="backgroundMain" id="Background"><Background/></div><div className="seperate">.....</div>
          <div className="skillsMain" id="Skills"><Skills/></div><div className="seperate">.....</div>
          <div className="personalDetailsMain" id="PersonalDetails"><PersonalDetails/></div><div className="seperate">.....</div>

        </div>
    )
}

export default Main;
